import { render, staticRenderFns } from "./u-mobile-header-basic.vue?vue&type=template&id=30f990ee&scoped=true"
import script from "./u-mobile-header-basic.vue?vue&type=script&lang=js"
export * from "./u-mobile-header-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f990ee",
  null
  
)

export default component.exports